module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-10.d163045e.jpg";